var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconLikeSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 16,
  viewBox: "0 0 18 16",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_261_4017",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 7,
  width: 6,
  height: 9
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7.273H5.09476V16H0V7.273Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_261_4017)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8.72017C0.0246803 8.63503 0.0473125 8.54932 0.07428 8.46483C0.294355 7.77501 1.00705 7.2772 1.78921 7.27475C2.83909 7.27147 3.88895 7.27376 4.93883 7.2741C4.98304 7.2741 5.02725 7.2784 5.09166 7.28171V7.45642C5.09166 10.1333 5.09064 12.8102 5.09477 15.4871C5.09497 15.6189 5.05411 15.6991 4.92842 15.7625C4.66561 15.8949 4.39208 15.991 4.09055 15.9921C3.29624 15.995 2.50118 16.0115 1.70776 15.986C0.876647 15.9594 0.206796 15.4049 0.0346822 14.6554C0.0279915 14.6263 0.0118111 14.5991 0 14.571V8.72017Z",
  fill: "#07567E"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask1_261_4017",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 5,
  y: 0,
  width: 13,
  height: 16
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.81152 0H17.4506V16H5.81152V0Z",
  fill: "white"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_261_4017)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0616 5.81257H11.2867C12.6893 5.81257 14.0919 5.81046 15.4944 5.8136C16.132 5.81503 16.6695 6.04856 17.0704 6.55182C17.5727 7.18256 17.5754 8.05907 17.0898 8.71762C17.0565 8.76285 17.0218 8.80716 16.9887 8.85075C17.7467 9.682 17.5424 10.9075 16.5713 11.4576C16.872 12.5055 16.7143 12.9812 15.885 13.6134C15.9208 13.9219 15.9929 14.2072 15.9792 14.4882C15.9391 15.308 15.2334 15.9893 14.4146 15.9928C12.0978 16.0023 9.78098 16.0035 7.46427 15.9897C6.92864 15.9865 6.41555 15.8226 5.91839 15.6194C5.80158 15.5717 5.81308 15.4897 5.81304 15.4004C5.81298 14.3441 5.81298 13.2877 5.81298 12.2314C5.81298 10.8173 5.81284 9.40321 5.81332 7.98909C5.81335 7.88449 5.79055 7.77454 5.90654 7.7019C5.93908 7.68156 5.9488 7.6239 5.96775 7.5828C6.62087 6.16837 7.27506 4.75439 7.92419 3.33812C7.9673 3.24404 7.99007 3.13228 7.99089 3.02851C7.99652 2.30162 7.99922 1.57462 7.99079 0.847762C7.98812 0.617242 8.07128 0.461001 8.27019 0.346816C8.55871 0.181188 8.86088 0.0639992 9.19121 0.0153553C9.73927 -0.0653422 10.1655 0.18153 10.5393 0.533028C11.3962 1.33871 11.7496 2.32855 11.599 3.50119C11.5034 4.24614 11.3211 4.96931 11.1009 5.68484C11.0911 5.71655 11.0814 5.7483 11.0616 5.81257Z",
  fill: "#07567E"
}))));
export default __webpack_public_path__ + "static/media/icon_like_solid.82d0383b.svg";
export { SvgIconLikeSolid as ReactComponent };